// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jc-1";
export var messageSideRight = "_jc-2";
export var orderLookupBubbleContainer = "_jc-0";
export var submitButton = "_jc-3";